// 详情页
import request from '@/service/request';
import config from '@/service/contant/config';
import api from '@/service/contant/api';

export function getBlindGoodsDetail(data, opt = {}) {
  return request({
    url: api.detail.getBlindGoodsDetail,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  });
}

export function createOrder(data, opt = {}) {
  return request({
    url: api.detail.createOrder,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  });
}
export function payProgress(data, opt = {}) {
  return request({
    url: api.detail.payProgress,
    method: 'POST',
    data,
    ...opt,
  });
}

export function openNormalBox(data, opt = {}) {
  return request({
    url: api.detail.openNormalBox,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  });
}
export function openPentaKillBox(data, opt = {}) {
  return request({
    url: api.detail.openPentaKillBox,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  });
}
export function openPromoBox(data, opt = {}) {
  return request({
    url: api.detail.openPromoteBox,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  }, {
    toast: false,
  });
}

// 用户回收卡数量
export function userRecycleCardNum(data, opt = {}) {
  return request({
    url: api.detail.userRecycleCardNum,
    method: 'GET',
    params: data,
    ...opt,
  });
}

// 获取分享参数
export function getBboxShareMark(data, opt = {}) {
  return request({
    url: api.detail.getBboxShareMark,
    method: 'GET',
    params: data,
    ...opt,
  });
}

// 订阅消息模板
export function subscribe(data, opt = {}) {
  return request({
    url: api.detail.subscribe,
    method: 'POST',
    data: {
      appId: config.platformId,
      ...data,
    },
    ...opt,
  });
}

// 回收卡配置
export function getRecycleCardConfig(data, opt = {}) {
  return request({
    url: api.detail.getRecycleCardConfig,
    method: 'GET',
    params: data,
    ...opt,
  });
}

// 是否有openId
export function isUserAuthorize(data, opt = {}) {
  return request({
    url: api.detail.isUserAuthorize,
    method: 'POST',
    data,
    ...opt,
  });
}

// 盲盒款式概率信息
export function patternRateInfo(data, opt = {}) {
  return request({
    url: api.detail.patternRateInfo,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  });
}

// 获取盲盒的可折扣金额信息
export function getBoxDiscountInfo(data, opt = {}) {
  return request({
    url: api.detail.getBoxDiscountInfo,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  });
}
// 领取天选之子卡
export function getReceiveSohCard(data, opt = {}) {
  return request({
    url: api.luckyCard.receiveSohCard,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  });
}
